import { render, staticRenderFns } from "./SearchPatient.vue?vue&type=template&id=4d640aae&scoped=true"
import script from "./SearchPatient.vue?vue&type=script&lang=js"
export * from "./SearchPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d640aae",
  null
  
)

export default component.exports